import { to } from "await-to-js";
import http from "../http";
import urls from "../urls";
import safeLocalStorage from "../../utils/localstorage";

export default new (class {
  login(data) {
    return to(http.post(`${urls.default.login}`, data));
  }
  logout() {
    return to(http.post(`${urls.default.logout}`));
  }

  cloneFormById(id) {
    return to(http.post(`${urls.forms.clone}/${id}`));
  }

  getAllForm() {
    //PAGINATION CONTROL
    var url = new URL(window.location.href);
    var page = url.searchParams.get("page");
    if (page === null) {
      return to(http.get(`${urls.forms.get}`));
    } else {
      return to(http.get(`${urls.forms.get + "?page=" + page}`));
    }
  }

  searchFormByName(data) {
    var url = new URL(window.location.href);
    var page = url.searchParams.get("page");
    if (page === null) {
      return to(http.post(`${urls.search.search}`, data));
    } else {
      return to(http.post(`${urls.search.search + "?page=" + page}`, data));
    }
  }

  getAllSubmit() {
    //PAGINATION CONTROL
    var url = new URL(window.location.href);
    var page = url.searchParams.get("page");
    if (page === null) {
      return to(http.get(`${urls.submit.get}`));
    } else {
      return to(http.get(`${urls.submit.get + "?page=" + page}`));
    }
  }

  getFormById(data) {
    return to(
      http.get(
        `${data.type === "noauth" ? urls.forms.getiframe : urls.forms.get}/${
          data.id
        }/${data.isShow}`
      )
    );
  }

  getFormData(data) {
    return to(http.get(`${urls.submit.get}/${data.id}`));
  }

  async postFormById(data) {
    let err, response;
    try {
      var formData = {};
      if (data.formData.action) {
        formData["status"] = 2;
      } else {
        formData = {
          name: data.formData.FormName,
          attributes: data.formData.Attributes,
          language: data.formData.language,
          type: data.formData.FormType,
          customerwidget: data.formData.CustomerWidget,
          customertype: data.formData.CustomerType,
          clients: data.formData.Clients,
          action: data.formData.ActionType,
          fields: JSON.stringify(data.formData.FormContent).split(",[]").join(""),
          success_page: data.formData.Success_Url,
          status: data.formData.status,
          created_by: JSON.parse(safeLocalStorage.getItem("user")).id
        };
      }
      [err, response] = await this.postFormRequest(formData, data.id);
      if (!err) {
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  }
  postFormRequest(data, id) {
    return to(http.post(`${urls.forms.get}/${id}`, data));
  }
  deleteFormById(id) {
    return to(http.delete(`${urls.forms.get}/${id}`));
  }
  addForm(data) {
    var formData = {
      name: data.FormName,
      attributes: data.Attributes,
      language: data.language,
      type: data.FormType,
      action: data.ActionType,
      clients: data.Clients,
      customerwidget: data.CustomerWidget,
      customertype: data.CustomerType,
      fields: JSON.stringify(data.FormContent).split(",[]").join(""),
      success_page: data.Success_Url,
      status: data.status,
      created_by: JSON.parse(safeLocalStorage.getItem("user")).id
    };
    return to(http.post(`${urls.forms.get}`, formData));
  }
  getMultipleForms(ids) {
    var formData = {
      id: ids
    };
    return to(http.post(`${urls.forms.multiple}`, formData));
  }
})();
